<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="disableSubmit"
    :cancelText="language['common.closeButton']">
    <cms-col-tbl-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></cms-col-tbl-form>
  </j-modal>
</template>

<script>

import CmsColTblForm from './CmsColTblForm'
export default {
  name: 'CmsColTblModal',
  components: {
    CmsColTblForm
  },
  data () {
    return {
      title:'',
      width:800,
      visible: false,
      disableSubmit: false
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    add () {
      this.visible=true
      this.disableSubmit=false;
      this.$nextTick(()=>{
        this.$refs.realForm.add();
      })
    },
    edit (record) {
      this.disableSubmit=false;
      this.visible=true
      this.$nextTick(()=>{
        this.$refs.realForm.edit(record);
      })
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleOk () {
      this.$refs.realForm.submitForm();
    },
    submitCallback(){
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel () {
      this.close()
    }
  }
}
</script>